<template>
  <el-dialog :title="titleName" :visible.sync="dialogVisible" width="50%" @close="closeDialog">
    
    <template v-if="type == 1">
      <template v-if="step==1">
        <!--  -->
        <el-table :inline="true"  :data="goods_list" ref="multipeTable1" :row-key="getRowkeys"  style="width: 100%" @selection-change="handleSelectionChange">
        <!-- :reserve-selection="true" -->
          <el-table-column width="55" type="selection" :reserve-selection="true"></el-table-column>
          <el-table-column label="商品图片">
            <template slot-scope="scope">
              <img :src="scope.row.goods_thumb" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称"></el-table-column>
          <el-table-column prop="shop_price" label="商品单价"></el-table-column>
          <el-table-column prop="goods_number" label="商品库存"></el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
        </el-table> 
        <div class="pag_wrap" style="margin-top: 15px">
          <el-pagination
            background
            :page-size="20"
            :current-page="listData1.page"
            layout="total, prev, pager, next"
            :total="all_page"
            @current-change="pageIndexChange"
          ></el-pagination>
        </div> 
      </template>
      <template v-else>
        <el-form ref="form" label-width="140px">
          <el-form-item label="预约有效期">
						<el-date-picker
							v-model="timeData"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							size="small"
							format="yyyy-MM-dd"
							value-format="timestamp"
							:picker-options="pickerOptions1"
						></el-date-picker>
					</el-form-item>
          <el-form-item label="预约时间段">
						<el-checkbox-group v-model="time_quantum">
              <el-checkbox label="0">00 - 01</el-checkbox>
              <el-checkbox label="1">01 - 02</el-checkbox>
              <el-checkbox label="2">02 - 03</el-checkbox>
              <el-checkbox label="3">03 - 04</el-checkbox>
              <el-checkbox label="4">04 - 05</el-checkbox>
              <el-checkbox label="5">05 - 06</el-checkbox>
              <el-checkbox label="6">06 - 07</el-checkbox>
              <el-checkbox label="7">07 - 08</el-checkbox>
              <el-checkbox label="8">08 - 09</el-checkbox>
              <el-checkbox label="9">09 - 10</el-checkbox>
              <el-checkbox label="10">10 - 11</el-checkbox>
              <el-checkbox label="11">11 - 12</el-checkbox>
              <el-checkbox label="12">12 - 13</el-checkbox>
              <el-checkbox label="13">13 - 14</el-checkbox>
              <el-checkbox label="14">14 - 15</el-checkbox>
              <el-checkbox label="15">15 - 16</el-checkbox>
              <el-checkbox label="16">16 - 17</el-checkbox>
              <el-checkbox label="17">17 - 18</el-checkbox>
              <el-checkbox label="18">18 - 19</el-checkbox>
              <el-checkbox label="19">19 - 20</el-checkbox>
              <el-checkbox label="20">20 - 21</el-checkbox>
              <el-checkbox label="21">21 - 22</el-checkbox>
              <el-checkbox label="22">22 - 23</el-checkbox>
              <el-checkbox label="23">23 - 00</el-checkbox>
            </el-checkbox-group>
					</el-form-item>
          <el-form-item label="预约数">
						<div>
              每个时间段最多可预约（
              <el-input class="yuyue-input w68"
                placeholder="人数"
                v-model="limit_people">
              </el-input>
              ）人
            </div>
					</el-form-item>
        </el-form>
      </template>
      <div class="weui-cell mb15 pl0 pr0">
        <div class="weui-cell__bd"></div>
        <div class="weui-cell__ft">
          <el-button size="small" @click="closeDialog"> 取消</el-button>
          <template v-if="step==1">
              <el-button size="small" type="primary" :disabled="checkList.length>0?false:true" @click="goStep"> 下一步</el-button>
          </template>
          <template v-if="step==2">
                <el-button type="primary"  @click="confirmSelect" size="small">确定</el-button>
          </template>
          
        </div>
      </div> 
    </template> 
        
    <template v-if="type ==2">
        <template v-if="yuangongstep == 1">
      
          <div class="shenheable">
            <!-- ref="multipeTable2" :row-key="getRowkeys" -->
            <el-table   :inline="true" ref="multipeTable2" :row-key="getRowkeys"  :data="employee_list" style="width: 100%"   @selection-change="handleSelectionChange">
              <!--  :reserve-selection="true" -->
               <el-table-column width="55" type="selection" :reserve-selection="true"></el-table-column>
              <el-table-column prop="name" label="员工名称"></el-table-column>
              <el-table-column prop="pic" label="头像">
                <template slot-scope="scope" align="center">
                    <img :src="scope.row.pic || 'static/img/userDefult.png'" alt width="60px" height="60px" />
                  </template>
              </el-table-column>
              <el-table-column prop="position" label="职位"></el-table-column>
              <el-table-column prop="phone" label="手机号"></el-table-column>
            </el-table>  
            </div>
            <div class="pag_wrap" style="margin-top: 15px">
              <el-pagination
                background
                :page-size="page.page_size"
                :current-page="page.current_page"
                layout="total, prev, pager, next"
                :total="page.total_rows"
                @current-change="pageIndexChange"
              ></el-pagination>
            </div> 
        </template>
        <template v-else>
           <el-form ref="form" label-width="140px">
              <el-form-item label="预约有效期">
                <el-date-picker
                  v-model="timeData"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  :picker-options="pickerOptions1"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="预约时间段">
                <el-checkbox-group v-model="time_quantum">
                  <el-checkbox label="0">00 - 01</el-checkbox>
                  <el-checkbox label="1">01 - 02</el-checkbox>
                  <el-checkbox label="2">02 - 03</el-checkbox>
                  <el-checkbox label="3">03 - 04</el-checkbox>
                  <el-checkbox label="4">04 - 05</el-checkbox>
                  <el-checkbox label="5">05 - 06</el-checkbox>
                  <el-checkbox label="6">06 - 07</el-checkbox>
                  <el-checkbox label="7">07 - 08</el-checkbox>
                  <el-checkbox label="8">08 - 09</el-checkbox>
                  <el-checkbox label="9">09 - 10</el-checkbox>
                  <el-checkbox label="10">10 - 11</el-checkbox>
                  <el-checkbox label="11">11 - 12</el-checkbox>
                  <el-checkbox label="12">12 - 13</el-checkbox>
                  <el-checkbox label="13">13 - 14</el-checkbox>
                  <el-checkbox label="14">14 - 15</el-checkbox>
                  <el-checkbox label="15">15 - 16</el-checkbox>
                  <el-checkbox label="16">16 - 17</el-checkbox>
                  <el-checkbox label="17">17 - 18</el-checkbox>
                  <el-checkbox label="18">18 - 19</el-checkbox>
                  <el-checkbox label="19">19 - 20</el-checkbox>
                  <el-checkbox label="20">20 - 21</el-checkbox>
                  <el-checkbox label="21">21 - 22</el-checkbox>
                  <el-checkbox label="22">22 - 23</el-checkbox>
                  <el-checkbox label="23">23 - 00</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="预约数">
                <div>
                  每个时间段最多可预约（
                  <el-input class="yuyue-input w68"
                    placeholder="人数"
                    v-model="limit_people">
                  </el-input>
                  ）人
                </div>
              </el-form-item>
            </el-form>
        </template>
        <div class="weui-cell mb15 pl0 pr0">
          <div class="weui-cell__bd"></div>
          <div class="weui-cell__ft">
            <el-button size="small" @click="closeDialog"> 取消</el-button>
            <template v-if="yuangongstep==1">
                <el-button size="small" type="primary" :disabled="checkList2.length>0?false:true"  @click="goStep2"> 下一步</el-button>
            </template>
            <template v-if="yuangongstep==2">
                  <el-button type="primary"  @click="confirmSelect2" size="small">确定</el-button>
            </template>
            
          </div>
        </div> 
    </template>
    
  </el-dialog>  
</template>

<script>
import { pagination } from "@/util/util.js";
import api from "@/api.js";

export default {
  name: 'merchantDialog',
  props: ['visible','type'], // type => 1-选择商品 2-选择成员
  data() {
    return {
      step:1,
      yuangongstep:1,
      titleName:'',
      goods_list:[],//商品列表
      employee_list:[],//成员列表
      checkList: [],//商品选中列表
      checkList2: [],//成员选中列表
      timeData: [],
  
      date_begin:'',//有效开始日期时间戳
      date_end:'',//有效结束日期时间戳
      time_quantum:[],//预约时间段 提交 预约时间段，英文逗号,隔开
      limit_people: "",//最多可预约人数

      all_page:0,
      current_page: 1,
      pagesize:6,
     page: {
        current_page: 1,
        page_size: 1,
        total_rows: 1
      },
      //选择商品参数
      listData1: {
        check_type: 1,
        goods_type: 0,
        name: '',
        cat_id: '',
        page: 1,
      },
      listData2: {
        name: '',
        page: 1
      },
      pickerOptions1: {
       
        disabledDate(time) {
          return time.getTime() < Date.now(); //  - 8.64e7 减去就是不包含今天的
        }
      },
      // 选泽员工
      // typemodul: '',

      dialogVisible: this.visible,
      // count: "",
      // result: [],

   

    }
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
      if (this.visible) {
        this.listData1.page = 1;
        this.listData2.page = 1;
        this.page.current_page = 1;
        this.checkList=[]
        this.checkList2=[]
        this.initFn();
      }
    },
    type: {
      immediate: true,
      handler(val) {
        // console.log('watch===',val)
        this.type = val
        if (this.type == 1) {
          this.titleName = '选择商品'
        }else{
          this.titleName = '选择成员'
        }
      }
      
    },
  },
  created(){
    

  },
  methods: {
    
    initFn() {
       let data =''
      if (this.type == 1) {
          data = this.listData1
          this.reUrl= api.goods_index
        }else{
          data = this.listData2
          this.reUrl= api.employeeList
        }
      let that =this
      this.axios
        .post(this.reUrl, data)
        .then(response => {
          // console.log('商品',response)
            if(parseInt(that.type)  == 1){
              that.goods_list = response.data.list
              that.all_page = response.data.all_page
              this.listData1.page = response.data.page
              this.setCheckedRows(this.checkList,this.goods_list,multipeTable1)
            }else{
            //  console.log('员工',response)
              that.employee_list =  response.data.result;
              response.data.page.current_page = parseInt(response.data.page.current_page);
  
              this.page = response.data.page;   
              this.setCheckedRows(this.checkList2,this.employee_list,multipeTable2)
            }         
        }).catch(() => {})
    },
    
    // 分页
    pageIndexChange(pageindex) {
      if(this.type==1){
        this.listData1.page = pageindex
      }else{
        this.listData2.page = pageindex;
      }
    
      this.initFn();
    },
    //设置row-key
    getRowkeys(row){
      return row.id
    },
    handleSelectionChange(val) {
      if(this.type==1){
        this.checkList = val
      }else{
        this.checkList2 = val
      }
    },
    
    //回显已勾选列表操作
    setCheckedRows(checkListName,tableData,tableName){
      let selectItem = []
      tableData.forEach((item)=>{
        checkListName.forEach(id => {
          if(item.id === id){
              selectItem.push(item)
          }
        })
      })
      this.$refs.tableName.toggleRowSelection(selectItem)
    },
 
    goStep(){
      this.step = 2;
      this.timeData=[]
      this.time_quantum=[]
       this.limit_people=''
    },
    goStep2(){
      this.yuangongstep = 2
      this.timeData=[]
      this.time_quantum=[]
      this.limit_people=''
    },
    confirmSelect() {
      // 选择商品确认按钮
       if(!this.timeData || this.timeData.length == 0){
        this.$message.error('请选择有效期时间');
        return
      }
      this.step =1;
      let obj = [];
      let btype=1;
      let time_quantum_str=""
      if (this.timeData && this.timeData.length > 0) {
        this.date_begin = this.timeData[0]/1000
        this.date_end = this.timeData[1]/1000
      } else {
        this.date_begin = "";
        this.date_end = "";
      }
      if(this.time_quantum && this.time_quantum.length > 0){
        time_quantum_str = this.time_quantum.join(',')
      }
      let newarr = this.checkList
      newarr.forEach((item,index)=>{
        let newCheck={
          date_begin:'',
          date_end:'',
          time_quantum:'',
          id:'',
          goods_name:'',
          limit_people:''
        }
        obj.push(newCheck);
        obj[index].date_begin = this.date_begin
        obj[index].date_end = this.date_end
        obj[index].time_quantum = time_quantum_str
        obj[index].limit_people = this.limit_people
        obj[index].id = item.id
        obj[index].goods_name = item.goods_name

      })
     
      this.$emit('updatePageInfo', obj, btype);
      this.$emit('update:visible', false);
      //提交后将这些变量置空
      this.date_begin=''
      this.date_end=''
      this.time_quantum=[]
      this.limit_people=''
    },
    confirmSelect2(){
      if(!this.timeData || this.timeData.length == 0){
        this.$message.error('请选择有效期时间');
        return
      }
      this.yuangongstep =1;
      let obj = [];
      let btype=2;
      let time_quantum_str=""
      
      if (this.timeData && this.timeData.length > 0) {
        this.date_begin = this.timeData[0]/1000
        this.date_end = this.timeData[1]/1000
      } else {
        this.date_begin = "";
        this.date_end = "";
      }
      if(this.time_quantum && this.time_quantum.length > 0){
        time_quantum_str = this.time_quantum.join(',')
      }
      let newarr2 = this.checkList2

      newarr2.forEach((item,index)=>{
        let newCheck={
          date_begin:'',
          date_end:'',
          time_quantum:'',
          id:'',
          employee_name:'',
          limit_people:''
        }
        obj.push(newCheck);
        obj[index].date_begin = this.date_begin
        obj[index].date_end = this.date_end
        obj[index].time_quantum = time_quantum_str
        obj[index].limit_people = this.limit_people
        obj[index].id = item.id
        obj[index].employee_name = item.name

      })
     
      this.$emit('updatePageInfo', obj, btype);
      this.$emit('update:visible', false);
      //提交后将这些变量置空
      this.date_begin=''
      this.date_end=''
      this.time_quantum=[]
      this.limit_people=''
    },
    closeDialog(){
      this.yuangongstep=1
      this.step=1
      this.$emit('update:visible',false)
    }
  }
}
</script>
<style  scoped>
.w68{ width: 68px;}
</style>
